var _a;
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { createSlice } from "@reduxjs/toolkit";
export var EBallotAuditStatus;
(function (EBallotAuditStatus) {
    EBallotAuditStatus["PREPARED"] = "prepared";
    EBallotAuditStatus["AUDITED"] = "audited";
})(EBallotAuditStatus || (EBallotAuditStatus = {}));
var initialState = {};
export var auditableBallotsSlice = createSlice({
    name: "auditableBallots",
    initialState: initialState,
    reducers: {
        setAuditableBallot: function (state, action) {
            state[action.payload.electionId] = {
                auditableBallot: action.payload.auditableBallot,
                isBlankBallot: action.payload.isBlankBallot,
                auditStatus: EBallotAuditStatus.PREPARED,
            };
            return state;
        },
        markBallotAudited: function (state, action) {
            var _a;
            var ballot = state[action.payload.electionId];
            if (((_a = ballot === null || ballot === void 0 ? void 0 : ballot.auditableBallot) === null || _a === void 0 ? void 0 : _a.ballot_hash) === action.payload.ballotHash)
                ballot.auditStatus = EBallotAuditStatus.AUDITED;
        },
        clearAuditableBallot: function (state, action) {
            var ballot = state[action.payload];
            // The confirmation keeps only its non-identifying blank-ballot flag.
            if (ballot)
                state[action.payload] = { isBlankBallot: ballot.isBlankBallot };
        },
    },
});
export var setAuditableBallot = (_a = auditableBallotsSlice.actions, _a.setAuditableBallot), markBallotAudited = _a.markBallotAudited, clearAuditableBallot = _a.clearAuditableBallot;
export var selectAuditableBallot = function (electionId) { return function (state) {
    var _a, _b;
    return ((_a = state.auditableBallots[electionId]) === null || _a === void 0 ? void 0 : _a.auditStatus) === EBallotAuditStatus.AUDITED
        ? undefined
        : (_b = state.auditableBallots[electionId]) === null || _b === void 0 ? void 0 : _b.auditableBallot;
}; };
export var selectBallotForAudit = function (electionId) { return function (state) { var _a; return (_a = state.auditableBallots[electionId]) === null || _a === void 0 ? void 0 : _a.auditableBallot; }; };
export var selectBallotAuditStatus = function (electionId) { return function (state) { var _a; return (_a = state.auditableBallots[electionId]) === null || _a === void 0 ? void 0 : _a.auditStatus; }; };
export var selectIsBlankBallot = function (electionId) { return function (state) { var _a, _b; return (_b = (_a = state.auditableBallots[electionId]) === null || _a === void 0 ? void 0 : _a.isBlankBallot) !== null && _b !== void 0 ? _b : false; }; };
export default auditableBallotsSlice.reducer;
